import { parseNumber } from '@/utils/index'
const RANGE_LON_MAX = 137.8347
const RANGE_LON_MIN = 72.004
const RANGE_LAT_MAX = 55.8271
const RANGE_LAT_MIN = 0.8293
const jzA = 6378245.0 // r of Earth
const jzEE = 0.00669342162296594323
function LAT_OFFSET_0(x: number, y: number) {
  return -100.0 + 2.0 * x + 3.0 * y + 0.2 * y * y + 0.1 * x * y + 0.2 * Math.sqrt(Math.abs(x))
}
function LAT_OFFSET_1(x: number) {
  return ((20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0) / 3.0
}
function LAT_OFFSET_2(y: number) {
  return ((20.0 * Math.sin(y * Math.PI) + 40.0 * Math.sin((y / 3.0) * Math.PI)) * 2.0) / 3.0
}
function LAT_OFFSET_3(y: number) {
  return (
    ((160.0 * Math.sin((y / 12.0) * Math.PI) + 320 * Math.sin((y * Math.PI) / 30.0)) * 2.0) / 3.0
  )
}

function LON_OFFSET_0(x: number, y: number) {
  return 300.0 + x + 2.0 * y + 0.1 * x * x + 0.1 * x * y + 0.1 * Math.sqrt(Math.abs(x))
}
function LON_OFFSET_1(x: number) {
  return ((20.0 * Math.sin(6.0 * x * Math.PI) + 20.0 * Math.sin(2.0 * x * Math.PI)) * 2.0) / 3.0
}
function LON_OFFSET_2(x: number) {
  return ((20.0 * Math.sin(x * Math.PI) + 40.0 * Math.sin((x / 3.0) * Math.PI)) * 2.0) / 3.0
}
function LON_OFFSET_3(x: number) {
  return (
    ((150.0 * Math.sin((x / 12.0) * Math.PI) + 300.0 * Math.sin((x / 30.0) * Math.PI)) * 2.0) / 3.0
  )
}

function transformLat(x: number, y: number) {
  // :(double)x bdLon:(double)y
  let ret = LAT_OFFSET_0(x, y)
  ret += LAT_OFFSET_1(x)
  ret += LAT_OFFSET_2(y)
  ret += LAT_OFFSET_3(y)
  return ret
}

function transformLon(x: number, y: number) {
  // :(double)x bdLon:(double)y
  let ret = LON_OFFSET_0(x, y)
  ret += LON_OFFSET_1(x)
  ret += LON_OFFSET_2(x)
  ret += LON_OFFSET_3(x)
  return ret
}

function outOfChina(lat: number, lon: number) {
  // :(double)lat bdLon:(double)lon
  if (lon < RANGE_LON_MIN || lon > RANGE_LON_MAX) return true
  if (lat < RANGE_LAT_MIN || lat > RANGE_LAT_MAX) return true
  return false
}

function delta (lat: number, lng: number) {
  let dLat = transformLat(lng - 105.0, lat - 35.0)
  let dLng = transformLon(lng - 105.0, lat - 35.0)
  const radLat = lat / 180.0 * Math.PI
  let magic = Math.sin(radLat)
  magic = 1 - jzEE * magic * magic
  const sqrtMagic = Math.sqrt(magic)
  dLat = (dLat * 180.0) / ((jzA * (1 - jzEE)) / (magic * sqrtMagic) * Math.PI)
  dLng = (dLng * 180.0) / (jzA / sqrtMagic * Math.cos(radLat) * Math.PI)
  return { 'lat': dLat, 'lng': dLng }
}


type IResult = {
  lat: number
  lng: number
}

export function wgs84ToGcj02({ lat, lng }: IResult): IResult {
  if (outOfChina(lat, lng)) { return { lat, lng } }
  const d = delta(lat, lng)
  return { 'lat': lat + d.lat, 'lng': lng + d.lng }
}

/**
 * GCJ-02 to WGS-84
 * @param {Number} lat 国测局坐标系纬度
 * @param {Number} lng 国测局坐标系纬度
 */
 export function gcj02ToWgs84 ({ lat, lng }: IResult): IResult {
  if (outOfChina(lat, lng)) { return { lat, lng } }
  const d = delta(lat, lng)
  return { 'lat': lat - d.lat, 'lng': lng - d.lng }
}